import { Component, input, computed } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-reps-calls-charts-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [{ provide: TabComponent, useExisting: RepsCallsChartsTabComponent }],
  templateUrl: './reps-calls-charts-tab.component.html',
  styleUrls: ['./reps-calls-charts-tab.component.scss'],
  standalone: true
})
export class RepsCallsChartsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('RepsCallsCharts');
  productId = input.required<string>();
  
  endpoint = computed(() => `/products/tables/seller-durations/${this.productId()}`);

  public async main(): Promise<void> {}
}
